import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GestockService } from '../services/gestock.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-edit-depot',
    templateUrl: './edit-depot.component.html',
    styleUrls: ['./edit-depot.component.css']
})
export class EditDepotComponent implements OnInit {

    nouveauNom: string;
    ancienNom: string;
    idDepot: any;
    samacaabiyoonwii: any;
    loading = false;

    constructor(
        public dialogRef: MatDialogRef<EditDepotComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private gestockService: GestockService,
        private snackBar: MatSnackBar
    ) {
        this.ancienNom = data.nomdepot;
        this.nouveauNom = data.nomdepot;
        this.idDepot = data.idPoint; // L'objet depot contient souvent 'id' ou 'idDepot', à vérifier lors de l'appel
    }

    ngOnInit(): void {
        this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    }

    onSave(): void {
        if (this.nouveauNom && this.nouveauNom.trim().length > 0 && this.nouveauNom !== this.ancienNom) {
            this.loading = true;
            this.gestockService.updateDepotName(this.samacaabiyoonwii, this.idDepot, this.nouveauNom)
                .then(response => {
                    this.loading = false;
                    if (response.statutreq === 1) {
                        this.snackBar.open('Nom du dépôt mis à jour avec succès', 'Fermer', { duration: 3000 });
                        this.dialogRef.close(true); // Retourne true pour indiquer le succès
                    } else {
                        this.snackBar.open('Erreur: ' + response.message, 'Fermer', { duration: 5000 });
                    }
                })
                .catch(error => {
                    this.loading = false;
                    this.snackBar.open('Erreur de connexion', 'Fermer', { duration: 5000 });
                    console.error(error);
                });
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
